import { mapDTO } from '@twistezo/ts-dto-mapper'

import { WorkspaceBidderDTO } from 'features/globalSetup/api/types/workspaceBidderDTO'
import { floatPercentToDTO } from 'utils/number'
import { EditSchema } from '../../../schemas/editSchema'
import { Variables } from './types'

type Props = {
  from: EditSchema
  workspaceBidderId: WorkspaceBidderDTO['id']
}

export const toDTO = ({ from, workspaceBidderId }: Props) =>
  mapDTO<EditSchema, Variables>({ from }).transform((data: EditSchema): Variables => {
    const {
      accountType,
      bidCpmAdjustment,
      bidderCode,
      bidderConfig,
      bidderConfigEnabled,
      bidderSid,
      consentMode,
      priority,
    } = data

    return {
      bidCpmAdjustment: floatPercentToDTO(bidCpmAdjustment),
      bidderCode: accountType === 'yieldbird' ? undefined : bidderCode,
      bidderConfig: JSON.parse(bidderConfig),
      bidderConfigEnabled,
      bidderSid: bidderSid || null,
      consentMode,
      enabled: accountType === 'yieldbird' && data.status !== 'available' ? false : undefined,
      priority,
      status: accountType === 'yieldbird' ? data.status : undefined,
      workspaceBidderId,
    }
  })
